<template>
  <div v-if="loading" class="ui active inverted dimmer loader-margin">
    <div class="ui text loader">{{ $t('loading') }}...</div>
  </div>
  <div v-else>
    <pageHeader :headerIcon="'recycle'"
                :headerText="$t('updateApprovalRequest')"
                :haveFilterInput="false"
                :columnsNumber="['six wide column', 'three wide column', 'seven wide column']">
    </pageHeader>
    <div style="padding-top: 50px;">
      <div class="ui segment">
        <a class="ui ribbon label" :class="getStateColorClass()">{{ approvalRequest.request.state }}</a>
        <div class="ui two column very relaxed stackable grid">
          <div class="column" style="border-right: 1px solid rgba(34,36,38,.15)">
            <h2 class="ui center aligned header">
              Old {{ approvalRequest.item.resource_type }} Values
            </h2>
            <abstractTable :data="resourceInfo"
                           :definitionTable="true"
                           :definitionTableWidth="'16%'"
                           :classes="'ui compact definition table'">
            </abstractTable>
          </div>
          <div class="column">
            <h2 class="ui center aligned header">
              New {{ approvalRequest.item.resource_type }} Values
            </h2>
            <abstractTable :data="newResourceInfo"
                           :definitionTable="true"
                           :definitionTableWidth="'16%'"
                           :classes="'ui compact definition table'">
            </abstractTable>
          </div>
        </div>
        <div class="ui divider"></div>
        <h3 class="ui center aligned header" style="margin-top: 10px;">
          {{ $t('updateReason') }}
          <br/>
          <h4>
            <div class="center aligned comment">
              <div class="content">
                <div class="text">
                  {{ approvalRequest.reason.content }}
                </div>
              </div>
            </div>
          </h4>
        </h3>
      </div>

      <div class="ui right floated button"
           @click="reject()"
           v-if="approvalRequest.request.state === 'pending'">
        <i class="close icon"></i>
        Reject
      </div>

      <div class="ui right floated green button" style="background-color: #092442"
           @click="approve()"
           v-if="approvalRequest.request.state === 'pending'">
        <i class="check icon"></i>
        Approve
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    abstractTable: require('@/components/abstract_components/AbstractTable').default,
    pageHeader: require('@/components/abstract_components/PageHeader').default
  },
  data () {
    return {
      loading: true,
      approvalRequest: {}
    }
  },
  mounted () {
    this.$http.get(`approvals/${this.$route.params.id}/compare`, {
      params: {
        clinic_id: this.getFromLocalStorage('clinicId')
      }
    }).then(response => {
      this.approvalRequest = response.data
      this.loading = false
    })
  },
  computed: {
    resourceInfo () {
      return {
        [this.$t('amount')]: this.approvalRequest.item.old_data.amount,
        [this.$t('paidAt')]: window.moment(this.approvalRequest.item.old_data.paid_at).format('DD/MM/YYYY hh:mm a'),
        [this.$t('description')]: this.approvalRequest.item.old_data.description
      }
    },
    newResourceInfo () {
      return {
        [this.$t('amount')]: this.approvalRequest.item.params.amount ? {
          html: true,
          value: `<p style="color: #f2711c">${this.approvalRequest.item.params.amount}</p>`
        } : `${this.$t('thereIsNoChangeInThisField')}.`,
        [this.$t('paidAt')]: this.approvalRequest.item.params.paid_at ? {
          html: true,
          value: `<p style="color: #f2711c">
            ${window.moment(this.approvalRequest.item.params.paid_at).format('DD/MM/YYYY hh:mm a')}</p>`
        } : `${this.$t('thereIsNoChangeInThisField')}.`,
        [this.$t('description')]: this.approvalRequest.item.params.description ? {
          html: true,
          value: `<p style="color: #f2711c">${this.approvalRequest.item.params.description}</p>`
        } : `${this.$t('thereIsNoChangeInThisField')}.`
      }
    }
  },
  methods: {
    approve () {
      this.$http.post(`approvals/${this.$route.params.id}/approve`, {
        clinic_id: this.getFromLocalStorage('clinicId')
      }).then(response => {
        this.navigateTo('Transactions')
      })
    },
    reject () {
      this.$http.post(`approvals/${this.$route.params.id}/reject`, {
        clinic_id: this.getFromLocalStorage('clinicId')
      }).then(response => {
        this.navigateTo('Transactions')
      })
    },
    getStateColorClass () {
      if (this.approvalRequest.request.state === 'pending') {
        return 'orange'
      } else if (this.approvalRequest.request.approved_at) {
        return 'green'
      } else if (this.approvalRequest.request.cancelled_at) {
        return 'black'
      } else if (this.approvalRequest.request.rejected_at) {
        return 'red'
      }
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/approval_requests/ApprovalRequest.vue